module.exports = "<div class=\"ui mini modal\" id=\"deleteConfirmation\">\n  <i class=\"close icon\"></i>\n  <div class=\"header\">\n    Suppression d'un utilisateur\n  </div>\n  <div class=\"content\">\n    Êtes-vous sûr de vouloir supprimer l'utilisateur {{email}} ?\n  </div>\n  <div class=\"actions\">\n    <div class=\"ui button red deny\">Cancel</div>\n    <div class=\"ui button positive approve\" (click)=\"deleteUser()\">\n      OK\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/user/delete-user/delete-user.component.html
// module id = ../../../../../src/app/_components/user/delete-user/delete-user.component.html
// module chunks = main